export const ADMIN_TABLE_LIMIT = 6;
export const PRODUCT_LIST_LIMIT = 8;
export const PRODUCT_RELATED_LIMIT = 4;
export const HOMEPAGE_PRODUCT_LIST_LIMIT = 8;
export const ADMIN_BLOG_TABLE_LIMIT = 8;
export const BLOG_LIST_LIMIT = 6;
